import React from "react";
import { motion } from "framer-motion";
import ContactInfoItem from "./ContactInfoItem";

const ContactInfo = () => {
    return (
        <section className="px-5 py-20 w-full bg-black max-sm:px-5 max-sm:py-10">
            <motion.div className="flex gap-10 justify-between mx-auto my-0 max-w-screen-xl max-md:flex-col max-md:gap-10 max-md:max-w-[600px]"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, ease: "easeOut" }}
                viewport={{ once: true }}
            >
                <ContactInfoItem icon="ti-email" title="Email Us">
                    <span>
                        For any inquiries or further information, feel free to reach out to
                        us via email at{" "}
                    </span>
                    <a
                        href="mailto:info@iexcel.my"
                        className="text-orange-500 no-underline"
                    >
                        info@iexcel.my
                    </a>
                    <span>. We aim to respond to all messages within 48 hours.</span>
                </ContactInfoItem>

                <ContactInfoItem icon="ti-headphone-alt" title="Call Us">
                    <span>You can contact us directly at </span>
                    <span className="font-bold">+6 (016) 293-2691</span>
                    <span>
                        . Our team is available to assist you from Monday to Friday, 9 AM to
                        5 PM.
                    </span>
                </ContactInfoItem>

                <ContactInfoItem icon="ti-location-pin" title="Visit Us">
                    <span>We welcome you to visit our office located at </span>
                    <span className="font-bold">
                        32-1, Jalan Temenggung 7/9, Bandar Mahkota Cheras, 43200 Cheras, Selangor, Malaysia
                    </span>
                    <span>. Please call ahead to schedule an appointment.</span>
                </ContactInfoItem>
            </motion.div>
        </section>
    );
};

export default ContactInfo;
